module.exports = __webpack_public_path__ + "static/media/S-14-Y.4cbd2cbd.mp3";